import { z } from "zod";
import { CommunityFeature } from "../enum.js";

const SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const createCommunityStep1Schema = z
	.object({
		name: z.string().min(3, { message: "Community name must be at least 3 characters" }).max(50),
		slug: z
			.string()
			.min(3, { message: "Slug must be at least 3 characters" })
			.max(30, { message: "Slug must be at most 30 characters" })
			.regex(SLUG_REGEX, { message: "Slug can only contain lowercase letters, numbers, and hyphens" }),
		description: z.string().max(500).optional(),
	})
	.strict();

export type CreateCommunityStep1Payload = z.infer<typeof createCommunityStep1Schema>;

export const createCommunityStep2Schema = z
	.object({
		image: z.url().optional(),
		variant: z.enum(["default", "coral", "green", "sky"]),
		features: z.array(z.enum(CommunityFeature)),
	})
	.strict();

export type CreateCommunityStep2Payload = z.infer<typeof createCommunityStep2Schema>;

export const createCommunitySchema = z
	.object({
		name: z.string().min(3, { message: "Community name must be at least 3 characters" }).max(50),
		slug: z
			.string()
			.min(3, { message: "Slug must be at least 3 characters" })
			.max(30, { message: "Slug must be at most 30 characters" })
			.regex(SLUG_REGEX, { message: "Slug can only contain lowercase letters, numbers, and hyphens" }),
		description: z.string().max(500).optional(),
		image: z.url().optional(),
		variant: z.enum(["default", "coral", "green", "sky"]),
		features: z.array(z.enum(CommunityFeature)),
	})
	.strict();

export type CreateCommunityPayload = z.infer<typeof createCommunitySchema>;
